module.exports = __webpack_public_path__ + "static/media/thumbnail.2fa3d48d.jpg";